import { render, staticRenderFns } from "./supplierCatTable.vue?vue&type=template&id=52dbcc10"
import script from "./supplierCatTable.vue?vue&type=script&lang=js"
export * from "./supplierCatTable.vue?vue&type=script&lang=js"
import style0 from "./supplierCatTable.vue?vue&type=style&index=0&id=52dbcc10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports